<!-- 找回密码 -->
<template>
  <div class="retrievePassword loginCom">
    <returnPage
      @retrievePassword="retrievePassword"
      type="retrievePassword"
      v-if="!this.$root.miniprogram"
    />
    <div class="retrievePsdMain loginMmain">
      <div class="retrievePsdMain_title">找回密码</div>
      <div class="PhoneNumIpt">
        <input
          type="tel"
          maxlength="11"
          placeholder="请输入手机号码"
          v-model="userTel"
          @keyup.delete="onDelete()"
        />
      </div>
      <div class="retrievePsdLine loginLine"></div>
    </div>
    <sendButton
      buttonText="发送验证码"
      @sendCodeBtn="forgetPsdBtn"
      :isActiveClass="isActiveClass"
      :yuntuColor="yuntuColor"
      loginWay="forgetPassword"
    />

    
  </div>
</template>

<script>
import '@/assets/css/loginCommon.css';
import { Toast } from 'vant';
import returnPage from '@/components/login/returnPage.vue';
import sendButton from '@/components/login/sendButton.vue';
import { queryCode, reqPhonesliderCode } from '@/api/login';
import { initCaptcha,triggerCaptcha } from '@/utils/tools';

export default {
  props: ['code'],
  components: { returnPage, sendButton },
  data() {
    return {
      userTel: '', // 手机号
      isActiveClass: false,
      yuntuColor: false,
    };
  },
  computed: {},
  watch: {
    userTel(val) {
      // const { userTel } = this;
      if (val?.length === 11) {
        this.isActiveClass = true;
        this.$store.dispatch('saveUserPhone', val);
        this.userTel = val;
        return;
      }
      this.isActiveClass = false;
    },
  },
  methods: {
    async forgetPsdBtn() {
      const { userTel } = this;

      const isPhone = /^1[3-9]\d{9}$/g.test(userTel);
      if (userTel?.length !== 11 || !isPhone) {
        Toast('请输入正确格式的手机号');
        return;
      }
      // 检查是否存在未过期的验证码
      const savedTimer = sessionStorage.getItem('forgetCodeTimer');
      if (savedTimer) {
        const timerData = JSON.parse(savedTimer);
        if (timerData.phone === userTel) {
          const remainTime = Math.ceil((timerData.endTime - Date.now()) / 1000);
          if (remainTime > 0) {
            // 同一手机号且倒计时未结束，直接跳转
            const obj = Object.assign(this.pagesParams ? JSON.parse(this.pagesParams) : {}, {
              loginWay: 'forgetPassword',
              loginSource: this.yuntuColor ? 'yuntulogin' : '',
            });
            this.$router.replace({
              name: 'getCode',
              params: obj,
              query: { redirect: this.$route.query.redirctUrl },
            });
            return;
          }
        }
      }

      const _this = this;
      triggerCaptcha()
    },
    // 发送验证码
    async getNewVerification(nvcVal) {
      const data = {
        company: this.yuntuColor ? 1 : 0,
        type: 'forgetPassword',
        phone: this.userTel,
        nvcVal,
        sceneId: '16dqi6jq'
      };
      const res = await reqPhonesliderCode(data);
      initCaptcha('16dqi6jq',this.nvcCallback);
      this.loading = false;
      if (res.code === 0) {
        if (res.data.status === 0) {
          this.isActiveClass = false;
          const obj = Object.assign(this.pagesParams ? JSON.parse(this.pagesParams) : {}, {
            loginWay: 'forgetPassword',
            loginSource: this.yuntuColor ? 'yuntulogin' : '',
          });
          sessionStorage.setItem(
            'forgetCodeTimer',
            JSON.stringify({
              phone: this.userTel,
              endTime: Date.now() + 59000,
              startTime: Date.now(),
            }),
          );
          this.$router.replace({
            name: 'getCode',
            params: obj,
            query: { redirect: this.$route.query.redirctUrl },
          });
        } else if (res.data.status === 1) {
          // 业务服务器请求回调控制是否需要二次验证
          if (res.data.bizCode === 800 || res.data.bizCode === 900) {
            // 无痕验证失败，直接拦截
            Toast('验证失败，请重新尝试');
          } else if (res.data.bizCode === 400) {
             triggerCaptcha()
          }
        }
      } else {
        Toast(res.msg);
      }
    },

    onDelete() {
      const { userPhone } = this.$store.state;
      if (userPhone?.length === 0) return;
      this.$store.dispatch('saveUserPhone', '');
    },

    retrievePassword() {
      this.$router.replace({
        path: '/passwordLogin',
        query: JSON.parse(this.urlParams),
        params: JSON.parse(this.pagesParams),
      });
    },
    Toast(msg) {
      Toast({
        message: msg,
        duration: 3 * 1000,
        position: 'top',
      });
    },
    nvcCallback(data){
      this.getNewVerification(data);
    }
  },
  created() {
    const { userPhone } = this.$store.state;
    this.userTel = userPhone || '';
    this.urlParams = window.localStorage.getItem('pagesQuery');
    this.pagesParams = window.localStorage.getItem('pagesParams');
    if (JSON.parse(this.urlParams)?.loginSource === 'yuntulogin') {
      this.yuntuColor = true;
    }
  },
  mounted() {
    initCaptcha('16dqi6jq',this.nvcCallback);
    document.getElementsByClassName('app')[0].setAttribute('style', 'background-color:#fff');
  },
  beforeDestroy() {
    document.getElementsByClassName('app')[0].removeAttribute('style');
  },
};
</script>
<style lang="scss" scoped>
.retrievePassword {
  .retrievePsdMain {
    .retrievePsdMain_title {
      padding: 89px 0 149px 0;
      color: #333;
      font-weight: 500;
      font-size: 51px;
    }

    .PhoneNumIpt {
      margin-bottom: 22px;
    }

    .retrievePsdLine {
      margin-bottom: 54px;
    }
  }
}

.sliderCode {
  margin-top: 45px;
}

::v-deep .nc_wrapper {
  margin: 0 auto;
}

::v-deep .nc-container .nc_scale .btn_ok,
::v-deep .nc-container .nc_scale span {
  height: 68px !important;
}
</style>
